(function () {
  "use strict";

  function init() {
    document.querySelectorAll("[data-pv-open]").forEach(function (btn) {
      var root = btn.closest(".pv-float");
      if (!root) return;
      var overlay = root.querySelector("[data-pv-overlay]");
      var closeBtn = root.querySelector("[data-pv-close]");
      var video = root.querySelector("[data-pv-video]");
      var preview = root.querySelector("[data-pv-preview]");

      function open() {
        if (preview) preview.pause();
        overlay.classList.add("is-open");
        overlay.setAttribute("aria-hidden", "false");
        if (video) {
          video.muted = false;
          video.loop = true;
          video.play().catch(function () {});
        }
      }

      function close() {
        overlay.classList.remove("is-open");
        overlay.setAttribute("aria-hidden", "true");
        if (video) video.pause();
        if (preview) preview.play().catch(function () {});
      }

      btn.addEventListener("click", open);
      if (closeBtn) closeBtn.addEventListener("click", close);

      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) close();
      });

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && overlay.classList.contains("is-open")) {
          close();
        }
      });

      if (video) {
        video.setAttribute("autoplay", "");
        video.setAttribute("loop", "");
        /* Click to replay: restart video from beginning */
        var videoWrap = root.querySelector(".pv-float__video-wrap");
        if (videoWrap) {
          videoWrap.style.cursor = "pointer";
          videoWrap.addEventListener("click", function (e) {
            if (e.target === video || e.target === videoWrap || videoWrap.contains(e.target)) {
              video.currentTime = 0;
              video.play().catch(function () {});
            }
          });
        }
      }

      /* Start preview video in floating block */
      var preview = root.querySelector("[data-pv-preview]");
      if (preview && preview.play) {
        preview.play().catch(function () {});
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
